
























import Vue from 'vue';

import { HELP_DETAILS, HELP_NOTES } from '../../config';
import Note from './note.vue';

export default Vue.extend({
  name: 'Help',

  components: {
    Note,
  },

  data: () => ({
    details: HELP_DETAILS,
    notes: HELP_NOTES,
  }),
});
